import PureMinusIcon from './minus.svg';

export default PureMinusIcon;
